export enum OrderStatuses {
    Pending = 1,
    Cancelled = 2,
    Accepted = 3,
    Shipped = 4,
    Ready_For_Pickup = 5,
    Delivered = 6,
    Declined = 7,
    On_Hold = 8,
    Completed = 9,
    Failed = 10,
    Received = 11,
    Processing = 12,
    Returned = 13,
    Refunded = 14,
    In_Complete = 15
}


// WEBPACK FOOTER //
// ./src/app/common/enums/orderStatus.enum.ts